import React, { useContext } from "react";
import { ProjectContext } from './../../contexts/ProjectContextProvider';
import DropdownInput from "../Inputs/DropdownInput";

const ProjectSelector = ({ setSelectedProject }) => {
    const { data: projects, loading, error } = useContext(ProjectContext);

    if (loading) {
        return <div>Loading projects...</div>;
    }

    if (error) {
        return <div>Error loading projects: {error}</div>;
    }

    const handleChange = (e) => {
        setSelectedProject(e.target.value);  // Capture the selected project ID
    };

    return (
        <div className="fs-5 mx-2 p-2">
            <DropdownInput

                name="project"
                options={projects}
                value=""
                onChange={handleChange}
                error={error ? "An error occurred while selecting the project." : ""}
                id="project-dropdown"
                fullWidth={false} // Adjust to true if you want it to take the full width
                labelColor="inherit"
                placeholder="Select a project"
                noOptionsText="No projects available"
            />
        </div>
    );
};

export default ProjectSelector;
